import { useState } from "react";
import { Mail, Lock, ShieldCheck, ArrowRight } from "lucide-react";
import { api } from "../context/AuthContext";
import "./VikiLogin.css";

export const VikiLogin = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const mood = success ? "happy" : loading ? "thinking" : "idle";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      setError("Inserisci email e password.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      // Stesso endpoint del portale: imposta i cookie di sessione condivisi
      // su .areapaq.it (withCredentials è già attivo sull'istanza api).
      await api.post("/auth/login", { email: email.trim(), password });
      setSuccess(true);
      setTimeout(() => onLoginSuccess(), 450);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        setError("Email o password non corrette.");
      } else {
        setError("Impossibile accedere in questo momento. Riprova tra poco.");
      }
      setLoading(false);
    }
  };

  return (
    <div className="viki-login-screen" data-testid="viki-pwa-login">
      <div className="viki-login-card">
        <span className="viki-login-badge"><span className="dot" /> Areapaq Ecosystem</span>
        <div className="viki-login-stage">
          <div className="halo" />
          <img src={`/viki/viki-${mood}.png`} alt="V.I.K.I." className="viki-login-logo" />
        </div>
        <h1>V.I.K.I.</h1>
        <p className="viki-login-subtitle">Il tuo copilota aziendale, sempre in tasca.<br />Accedi con le credenziali AREAPAQ.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="viki-login-email">Email</label>
          <div className="viki-login-field">
            <span className="field-icon"><Mail size={16} /></span>
            <input
              id="viki-login-email"
              data-testid="viki-pwa-login-email"
              type="email"
              autoComplete="username"
              placeholder="nome@azienda.it"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          <label htmlFor="viki-login-password">Password</label>
          <div className="viki-login-field">
            <span className="field-icon"><Lock size={16} /></span>
            <input
              id="viki-login-password"
              data-testid="viki-pwa-login-password"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>

          {error && <p className="viki-login-error" data-testid="viki-pwa-login-error">{error}</p>}

          <button type="submit" disabled={loading} data-testid="viki-pwa-login-submit">
            {loading ? (
              <>
                <span className="viki-login-spinner" /> {success ? "Benvenuto!" : "Accesso in corso…"}
              </>
            ) : (
              <>
                Accedi <ArrowRight size={16} strokeWidth={2.8} />
              </>
            )}
          </button>
        </form>

        <div className="viki-login-footer">
          <ShieldCheck size={13} /> Accesso sicuro all'ecosistema AREAPAQ
        </div>
      </div>
    </div>
  );
};

export default VikiLogin;
